<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
  >
    <a-form :form="form">
      <label>配置型号</label>
      <a-tree
        checkable
        @expand="onExpand"
        :expandedKeys="expandedKeys"
        :autoExpandParent="autoExpandParent"
        @select="onSelect"
        v-model="selectedKeys"
        :treeData="modelData"
      />
    </a-form>
  </a-modal>
</template>
<script>

import { selectAllModel, selectModelRelated,configModel } from '@/api/enterprise/model'

import pick from 'lodash.pick'

export default {
  name: 'EnterpriseDetailsModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      modelData: [],
      visible: false,
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this)
    }
  },
  watch: {
    checkedKeys (val) {

      console.log('onCheck', val)
    }
  },
  beforeCreate () {
  },
  created () {
  },
  methods: {
    onExpand (expandedKeys) {

      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck (checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
    },
    onSelect (selectedKeys, info) {

      console.log('onSelect', info)
      this.selectedKeys = selectedKeys
    },
    add (parentId) {
      this.form.resetFields()
      this.visible = true
      selectAllModel({ 'enterpriseId': parentId }).then(res => {
        if (res.code === 0) {
          this.enterpriseId = parentId
          this.modelData = res.data

          selectModelRelated({ 'enterpriseId': parentId }).then(res => {
            if (res.code === 0) {
              this.selectedKeys = res.data
            }
          })
        }
      })
    },
    edit (record) {
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl, 'enterprisePriceId', 'enterpriseId', 'installationType', 'priceType', 'price', 'application', 'proportion', 'priceRemark', 'status', 'delStatus', 'createUser', 'createTime', 'updateUser', 'updateTime'))
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true
          console.log(this.selectedKeys)
          configModel({ 'enterpriseId': this.enterpriseId, 'modelIds': this.selectedKeys }).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('ok')
              this.visible = false
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    }
  }
  // watch: {
  //   /*
  //     'selectedRows': function (selectedRows) {
  //       this.needTotalList = this.needTotalList.map(item => {
  //         return {
  //           ...item,
  //           total: selectedRows.reduce( (sum, val) => {
  //             return sum + val[item.dataIndex]
  //           }, 0)
  //         }
  //       })
  //     }
  //     */
  // }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>